__turbopack_context__.v({
  "root": "EmptyMessage-module-scss-module__tuSQGq__root",
});
